import { type FunctionComponent, useState } from 'react';

import { Button, Dropdown } from '@dr.pogodin/react-utils';

import InputVolume from 'components/InputVolume';

import { useInput } from 'hooks/audio';

import S from './style.scss';
import dropdownTheme from '../dropdown.scss';

type PropsT = {
  devices: MediaDeviceInfo[];
  setInputByLabel: (label: string) => void;
};

export const AudioInput: FunctionComponent<PropsT> = ({
  devices,
  setInputByLabel,
}) => {
  const input = useInput();

  const [edit, setEdit] = useState(false);

  return (
    <div className={S.container}>
      {edit ? (
        <Dropdown
          label="Input"
          onChange={(e) => {
            setInputByLabel(e.target.value);
            setEdit(false);
          }}
          onClick={() => {
            setEdit(false);
          }}
          options={devices.map((d) => d.label)}
          theme={dropdownTheme}
          value={input.label}
        />
      ) : (
        <div styleName="disabled">
          <div className={S.label}>Input</div>
          <div styleName="value">
            {input.label || 'Default'}
          </div>
          <Button
            onClick={() => {
              setEdit(true);
            }}
          >
            Change
          </Button>
        </div>
      )}
      <InputVolume source={input.stream} />
    </div>
  );
};
